import { MutantApiService } from "../../../../services/MutantApiService";

const api = new MutantApiService();

export const fetchModelById = async (id) => {
    try {
        const response = await api.makeHttpRequest({
            method: "GET",
            url: `/models/${id}`,
        });
        let model = response;
        if (!model) return model;
        if (model.data && typeof model.data !== 'string') {
            model = model.data;
        }
        if (model.data && typeof model.data !== 'string') {
            // handle nested data: { data: { data: <model> } }
            model = model.data;
        }
        if (model.model) {
            model = model.model;
        }

        return model;
    } catch (e) {
        throw e?.response?.data?.messages?.[0] || "Erro ao recuperar Modelos.";
    }
};

export const saveModel = async (id, formData) => {
    try {
        const method = id ? "PATCH" : "POST";
        const url = id ? `/models/${id}` : "/models";
        
        console.log(`[ModelApiService] ${method} ${url}`);
        console.log(`[ModelApiService] FormData contents:`);
        for (let [key, value] of formData.entries()) {
            if (key === "providerConfig") {
                try {
                    const parsedConfig = JSON.parse(value);
                    console.log(`  ${key}:`, parsedConfig);
                } catch (e) {
                    console.log(`  ${key}: ${value}`);
                }
            } else {
                console.log(`  ${key}: ${value}`);
            }
        }
        
        await api.makeHttpRequest({
            method,
            url,
            data: formData,
            timeout: 1200000,
        });
    } catch (e) {
        throw e;
    }
};

export const modelApiHelper = {
    fetchModelById,
    saveModel,
};